import React from "react";
import { Zap, Sun, Layers, BatteryCharging, Shirt, ShieldCheck, Sparkles, Calculator } from "lucide-react";

const BENEFITS = [
  { icon: Zap, title: "500W low power", desc: "Roughly a quarter of the draw of an ordinary 2,000W iron." },
  { icon: Sun, title: "Built for solar & inverter", desc: "Designed from day one for homes that run on backup power." },
  { icon: Layers, title: "Ceramic non-stick soleplate", desc: "Smooth glide on delicate fabrics — no sticking, no shine marks." },
  { icon: BatteryCharging, title: "Reduced battery load", desc: "Iron through the morning rush without flattening your bank." },
  { icon: Shirt, title: "Home & professional pressing", desc: "From daily shirts to a tailor's finishing table." },
  { icon: ShieldCheck, title: "12-month warranty", desc: "Every CORE 500 is covered, Nigeria-wide." },
  { icon: Sparkles, title: "Premium, practical design", desc: "Adjustable thermostat, 1.5m cord, light 750g body." },
];

export default function WhyCoreSection() {
  return (
    <section data-testid="why-core-section" className="py-20 md:py-28" style={{ background: "var(--surface)", borderBottom: "1px solid var(--border)" }}>
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-8 items-end">
          <div className="md:col-span-7">
            <div className="eyebrow">Our purpose</div>
            <h2 className="display mt-4" style={{ fontSize: "clamp(2rem, 4.5vw, 4rem)", color: "var(--ink)" }}>
              Why SunPressSolar built <span className="sunset-text">the CORE 500</span>.
            </h2>
          </div>
          <div className="md:col-span-5 text-base" style={{ color: "var(--ink-soft)" }}>
            Traditional high-watt irons were never designed for homes that depend on solar,
            inverters, batteries and generators. SunPressSolar exists to build practical,
            energy-conscious appliances for that reality — starting with the iron.
          </div>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-px" style={{ background: "var(--border)" }}>
          {BENEFITS.map((f) => {
            const I = f.icon;
            return (
              <div key={f.title} className="p-7 md:p-9" style={{ background: "var(--surface)" }}>
                <I size={26} color="var(--sun-orange)" strokeWidth={1.5} />
                <h3 className="font-serif text-xl mt-5" style={{ color: "var(--ink)" }}>{f.title}</h3>
                <p className="mt-2.5 text-sm leading-relaxed" style={{ color: "var(--ink-soft)" }}>{f.desc}</p>
              </div>
            );
          })}
          <a
            href="#calculator"
            data-testid="why-core-calc-link"
            className="p-7 md:p-9 flex flex-col justify-between group"
            style={{ background: "linear-gradient(135deg, #1A1F27, #0E1116)" }}
          >
            <Calculator size={26} color="var(--sun-amber)" strokeWidth={1.5} />
            <div>
              <h3 className="font-serif text-xl mt-5" style={{ color: "#FCF6EA" }}>See it in your budget</h3>
              <p className="mt-2.5 text-sm leading-relaxed sunset-text font-medium">
                Calculate your battery &amp; fuel savings →
              </p>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
